/* eslint-disable */
import Colors from '../../Support/Theme/Colors/Colors';

/**
 * Create styles for `<BrowserNotSupported />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<BrowserNotSupported />` styles
 */
const browserNotSupportedStyles = ({ theme }) => ({
  body: {
    backgroundColor: 'red',
  },
  pageWrapper: {
    backgroundColor: theme.palette.grey[200],
    padding: theme.spacing(6),
    minHeight: `100vh`,
  },
  containerWrapper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
    textAlign: `center`,
    alignContent: `flex-start`,
    minHeight: `calc(100vh - 72px)`,
    padding: theme.spacing(2),
  },
  logosWrapper: {
    margin: `${theme.spacing(3)}px auto 0 auto`,
    maxWidth: 638,
    marginBottom: theme.spacing(2),
  },
  content: {
    maxWidth: 638,
    margin: `0 auto`,
  },
  imgBoralLogo: {
    marginTop: theme.spacing(5),
    marginBottom: -theme.spacing(1),
    position: `relative`,
    left: theme.spacing(1),
  },
  browserLink: {
    textDecoration: `underline`,
    color: Colors.boralgreen[500],
    fontWeight: 500,
    textTransform: 'capitalize'
  },
  h1: {
    ...theme.typography.h4,
  },
  browserNotSupported: {
    position: `absolute`,
    top: theme.spacing(2),
    left: theme.spacing(5),
    opacity: 0.5,
  },
  button: {
    minWidth: 114,
  }
});

export default browserNotSupportedStyles;
